<template>
    <div id="quick-stats" class="panel-group row">
        <div class="col-sm-12 col-lg-3">
            <div class="card-panel" @click="goToRoute('/posts')">
                <div class="card-panel-icon-wrapper icon-people">
                    <i class="fa fa-newspaper card-panel-icon"></i>
                </div>
                <div class="card-panel-description">
                    <div class="card-panel-text">
                        Cikkek
                    </div>
                    <span class="card-panel-num">
                        {{ dashboard_data.post_count ? dashboard_data.post_count.total : 0 }}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-lg-3">
            <div class="card-panel" @click="goToRoute('/reports/post-visitors')">
                <div class="card-panel-icon-wrapper icon-cbr">
                    <i class="fas fa-user-friends card-panel-icon"></i>
                </div>
                <div class="card-panel-description">
                    <div class="card-panel-text">
                        Látogatók
                    </div> <span class="card-panel-num">
                        {{ dashboard_data.visitors_count && dashboard_data.visitors_count.total ? dashboard_data.visitors_count.total : 0 }}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-lg-3">
            <div class="card-panel" @click="goToRoute('/campaigns')">
                <div class="card-panel-icon-wrapper icon-invoice">
                    <i class="fa fa-images card-panel-icon"></i>
                </div>
                <div class="card-panel-description">
                    <div class="card-panel-text">
                        Kampányok
                    </div> <span class="card-panel-num">
                        {{ dashboard_data.campaigns_count ? dashboard_data.campaigns_count.total : 0 }}
                    </span>
                </div>
            </div>
        </div>
        <div class="card-panel-col col-sm-12 col-lg-3">
            <div class="card-panel" @click="goToRoute('/campaigns/banners')">
                <div class="card-panel-icon-wrapper icon-card">
                    <i class="fa fa-image card-panel-icon"></i>
                </div>
                <div class="card-panel-description">
                    <div class="card-panel-text">
                        Bannerek
                    </div>
                    <span class="card-panel-num">
                        {{ dashboard_data.banners_count ? dashboard_data.banners_count.total : 0 }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'quick-stats',
        props: ['data'],
        data() {
            return {

            }
        },
        computed: {
            dashboard_data: {
                get: function() {
                    return this.data ? this.data : {
                        post_count: {
                            total: 0,
                        },
                        visitors_count: {
                            total: 0,
                        },
                        campaigns_count: {
                            total: 0,
                        },
                        banners_count: {
                            total: 0,
                        }
                    };
                },
                set: function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            goToRoute(path) {
                if(path) {
                    this.$router.push({
                        path: path,
                    });
                }
            }
        },
        watch: {
            data: function(newVal) {
                this.dashboard_data = newVal;
            }
        }
    }
</script>


<style scoped lang="scss">
    .panel-group {
        margin-top: 18px;

        .card-panel {
            height: 122px;
            cursor: pointer;
            font-size: 12px;
            position: relative;
            overflow: hidden;
            color: #666;
            background: #fff;
            box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
            border-color: rgba(0, 0, 0, 0.05);
            padding: 27px 10px 10px 15px;
            margin: 10px;
            border-radius: 6px;

            .icon-people {
                color: #40c9c6;
            }

            .icon-cbr {
                color: #007bff;
            }

            .icon-invoice {
                color: #f4516c;
            }

            .icon-card {
                color: #28a745;
            }

            .card-panel-icon-wrapper {
                float: left;

                i {
                    font-size: 50px;
                }
            }

            .card-panel-icon {
                float: left;
                font-size: 48px;
            }

            .card-panel-description {
                float: right;
                font-weight: 700;
                margin: 0px 11px 0px 0px;
                text-align: center;

                .card-panel-text {
                    line-height: 18px;
                    color: rgba(0,0,0,.45);
                    font-size: 16px;
                    margin-bottom: 12px;
                }

                .card-panel-num {
                    font-size: 20px;
                }
            }
        }

        .card-panel:hover {
            -webkit-box-shadow: 3px 10px 16px -15px rgba(0,0,0,0.75);
            -moz-box-shadow: 3px 10px 16px -15px rgba(0,0,0,0.75);
            box-shadow: 3px 10px 16px -15px rgba(0,0,0,0.75);
            transition: width 2s;
        }
    }

    .el-row {
        position: relative;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .el-row:after, .el-row:before {
        display: table;
        content: "";
    }


</style>